/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:17:05
*/


const localesReducer = (state = {}, action) => {
	if(action.type === 'SET_LOCALE') {
		return action.newLocale
	} else {
		return state
	}	
}

export default localesReducer;
